import React from "react";
import { Box } from "@mui/material";
import { Page } from "../components/Page";
import { GameCatalog } from "./GameCatalog";

export function GameList() {
  return (
    <Page
      title="Games"
      description="Play browser games remade from classic projects"
    >
      <Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        <GameCatalog />
      </Box>
    </Page>
  );
}
